import {g as l, f as h} from '@theme/global';
import '@theme/request-idle-callback';
import '@theme/combined-listings';
import '@theme/theme-sections';
import '@theme/product-video';
class m extends HTMLElement {
  constructor() {
    super(),
      (this.form = this.querySelector('form')),
      (this.form.querySelector('[name=id]').disabled = !1),
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this)),
      (this.cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer')),
      (this.submitButton = this.querySelector('[type="submit"]')),
      document.querySelector('cart-drawer') && this.submitButton.setAttribute('aria-haspopup', 'dialog');
    const t = this.querySelector('[data-product-json]');
    this.productJson = t ? JSON.parse(t.textContent) : null;
  }
  getSelectedVariant() {
    const t = this.productJson,
      i = Number(this.form.querySelector('[name="id"]').value);
    return !i || isNaN(i)
      ? t == null
        ? void 0
        : t.variants[0]
      : (t == null ? void 0 : t.variants.find((r) => r.id === i)) || (t == null ? void 0 : t.variants[0]);
  }
  getActiveOptions(t) {
    var d;
    const i = this.getSelectedVariant(),
      r = this.productJson;
    if (!(r != null && r.variants) || !i) return [];
    const s = (d = r.options_with_values) == null ? void 0 : d.find((a) => a.name === t);
    if (!s) return r.variants;
    const e = s.position - 1;
    if (e === -1) return r.variants;
    const o = i.options;
    if (o.length <= 1) return r.variants;
    const n = o.filter((a, c) => c !== e);
    return r.variants.filter((a) => n.every((c, u) => a.options[u] === c));
  }
  onSubmitHandler(t) {
    if (
      (t.preventDefault(),
      this.closest('[data-combined-listings-busy]') || this.submitButton.getAttribute('aria-disabled') === 'true')
    )
      return;
    const i = new FormData(this.form);
    if (i.get('id') === '') {
      this.openVariantSelector();
      return;
    }
    this.handleErrorMessage(),
      this.submitButton.setAttribute('aria-disabled', !0),
      this.submitButton.classList.add('loading'),
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden'),
      (document.querySelector('.cart-drawer .overlay').style.display = 'block');
    const s = h('javascript');
    (s.headers['X-Requested-With'] = 'XMLHttpRequest'),
      delete s.headers['Content-Type'],
      this.cartNotification &&
        (i.append(
          'sections',
          this.cartNotification.getSectionsToRender().map((e) => e.id)
        ),
        i.append('sections_url', window.location.pathname),
        this.cartNotification.setActiveElement(document.activeElement)),
      (s.body = i),
      fetch(`${window.routes.cart_add_url}`, s)
        .then((e) => e.json())
        .then((e) => {
          if (e.status) {
            this.handleErrorMessage(e.description);
            const n = this.submitButton.querySelector('.sold-out-message');
            if (!n) return;
            this.submitButton.setAttribute('aria-disabled', !0),
              this.submitButton.querySelector('span').classList.add('hidden'),
              n.classList.remove('hidden'),
              (this.error = !0);
            return;
          } else if (!this.cartNotification) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = !1;
          const o = this.closest('quick-add-modal');
          o
            ? (document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cartNotification.renderContents(e);
                  });
                },
                {once: !0}
              ),
              o.hide(!0))
            : this.cartNotification.renderContents(e);
        })
        .catch((e) => {
          window.console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading'),
            this.cartNotification &&
              this.cartNotification.classList.contains('is-empty') &&
              this.cartNotification.classList.remove('is-empty'),
            this.error || this.submitButton.removeAttribute('aria-disabled'),
            this.querySelector('.loading-overlay__spinner').classList.add('hidden'),
            l();
        });
  }
  handleErrorMessage(t = !1) {
    (this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')),
      this.errorMessageWrapper &&
        ((this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')),
        this.errorMessageWrapper.toggleAttribute('hidden', !t),
        t && (this.errorMessage.textContent = t));
  }
  openVariantSelector() {
    const t = this.form.querySelector('component-variant-select');
    t && t.toggle(null, 'open');
  }
}
customElements.get('product-form') || customElements.define('product-form', m);
